import { render, staticRenderFns } from "./Lockbox.vue?vue&type=template&id=6752532c&"
import script from "./Lockbox.vue?vue&type=script&lang=js&"
export * from "./Lockbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports